import { AxiosError } from "axios";
import React, {
  FC,
  useState,
  useContext,
  createContext,
  useCallback,
} from "react";
import { getMessageList } from "../apis/message";
import { Pagination } from "../interfaces/common";
import { Message } from "../interfaces/message";

type MessageListContext = {
  error: Error|null;
  messageList: Message[];
  fetching: boolean;
  fetchMessageList: (refresh?: boolean, page?: number) => {};
};
const messageListContext = createContext({} as MessageListContext);

export const MessageListProvider: FC = ({ children }) => {
  const [messageList, setMessageList] = useState<Message[]>([]);
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState<Error|null>(null);

  const fetchMessageList = useCallback(async (refresh: boolean = true, page: number | null = null) => {
    try {
      if (refresh) setFetching(true);
      setError(null)
      const response = await getMessageList();
      const paginatedData: Pagination = response.data;
      setMessageList(paginatedData.data);
      if (refresh) setFetching(false);
    } catch (error) {
      if (refresh) setFetching(false);
      const axiosError = error as AxiosError;
      setError(axiosError);
    }
  }, []);

  return (
    <messageListContext.Provider value={{ error, messageList, fetching, fetchMessageList }}>
      {children}
    </messageListContext.Provider>
  );
};

export const useMessageList = () => {
  const { error, messageList, fetching, fetchMessageList } = useContext(messageListContext);
  return { error, messageList, fetching, fetchMessageList };
};
